import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    sucursales: [],
    sucursal: {},
})

export default function sucursalesReducer(state = initialState, action) {
    if(action.type === ReducerActions.SET_SUCURSALES){
        return state.setIn(["sucursales"], action.payload)
    }
    
    if(action.type === ReducerActions.SAVE_SUCURSAL){
        return state.setIn(["sucursal"], action.payload)
    }

    return state
}
